// utils/renderRequiredAsterisk.js
const requiredFields = [
    "productBrandName",
    "productName",
    "productCategory",
    "productSubCategory",
    "productMetal",
    "productStamp",
    "productMeltingPurity",
    "grossWeight",
    "lessWeight",
    "productPrice",
    "productCode",
    "productQuantity",
    "productWastageOfRetailer",
    "productWastageOfWholesaler",
    "retailerRate",
    "wholesalerRate",
    "perPcsFineRetailer",
    "labourRetailer",
    "minimumQtyRetailer",
    "perPcsFineWholesaler",
    "labourWholesaler",
    "minimumQtyWholesaler",
    "wastageWholesaler",
  ];
  
  const requiredAsteriskStyle = {
    color: 'red',
    marginLeft: '5px',
  };
  
  export const renderRequiredAsterisk = (name) =>
    requiredFields.includes(name) && <span style={requiredAsteriskStyle}>*</span>;
  
  export const canCancelOrder = (orderDate) => {
    if (!orderDate) return false;

    const createdTime = new Date(orderDate).getTime();
    const currentTime = new Date().getTime();

    const diffInMinutes = (currentTime - createdTime) / (1000 * 60);

    return diffInMinutes <= 30;
  };
